import { IState } from '../../interfaces/state.interface';

const baseAdminTabsSelector = ['adminTabs'];

export const selectActiveAdminTab = (state: IState): string => state.getIn([...baseAdminTabsSelector, 'activeTab']);
